import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <div style={{ width: '100%', position: 'relative', zIndex: 1 }}>
            <footer className="app-footer">
                <div className="footer-content">
                    <div className="footer-links">
                        <Link to="/terms" className="footer-link">
                            Terms of Service
                        </Link>
                        <span className="footer-separator">•</span>
                        <Link to="/privacy" className="footer-link">
                            Privacy Policy
                        </Link>
                        <span className="footer-separator">•</span>
                        <a href="mailto:support@cutiq.io" className="footer-link">
                            Contact
                        </a>
                        <span className="footer-separator">•</span>
                        <a href="https://affiliates.cutiq.ai/" target="_blank" rel="noopener noreferrer" className="footer-link">
                            Affiliates
                        </a>
                    </div>
                    <div className="footer-copyright">
                        <p>© {currentYear} CutIQ by The Trend Junkies. All rights reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};
